// if ( typeof AnnouncementBar !== 'function' ) {

//   class AnnouncementBar extends HTMLElement {

//     constructor() {

//       super();

//       this.slider = this.querySelector('[data-js-slider]');
//       this.content = this.querySelectorAll('.announcement');
//       this.nextButton = this.querySelector('.announcement-bar__content-nav--right');
//       this.prevButton = this.querySelector('.announcement-bar__content-nav--left');

//       this.index = 0;
//       this.length = this.content.length;
      
//       this.nextButton.addEventListener('click', ()=>{
//         this.changeSlide('next')
//       });
//       this.prevButton.addEventListener('click', ()=>{
//         this.changeSlide('prev')
//       });
//     }

//     changeSlide(direction) {

//       this.nextButton.classList.remove('announcement-bar__content-nav--disabled')
//       this.prevButton.classList.remove('announcement-bar__content-nav--disabled')

//       if ( direction == 'next' ) {
//         this.index++;
//       } else if ( direction == 'prev' ) {
//         this.index--;
//       }

//       if ( this.index == this.length - 1 ) {
//         this.nextButton.classList.add('announcement-bar__content-nav--disabled')
//       } else if ( this.index == 0 ) {
//         this.prevButton.classList.add('announcement-bar__content-nav--disabled')
//       }

//       this.slider.scrollTo({
//         top: 0,
//         left: this.content[this.index].offsetLeft,
//         behavior: 'smooth'
//       });

//     }

//   }

//   if ( typeof customElements.get('announcement-bar') == 'undefined' ) {
//     customElements.define('announcement-bar', AnnouncementBar);
// 	}

// }

//announcement-bar__slider
// var swiper = new Swiper(".announcement-bar__slider ", {
//   loop: true,
//   slidesPerView: 1,
//   slidesPerGroup: 1,
//   autoplay: {
//     delay: 2500,
//     disableOnInteraction: false,
//   },
// });

// var swiper = new Swiper(".announcement_bar__slider", {
//   loop: true,
//   autoplay: {
//     delay: 2500,
//     disableOnInteraction: false,
//   },
// });


document.addEventListener('DOMContentLoaded', () => {
  try {
    const announcementBar = document.querySelector(".announcement-bar__slider")
    let delayMobile = 0
    let delayDesktop = 0
    if (announcementBar) {
      delayMobile = announcementBar.getAttribute("data-autodelay-mobile")
      delayDesktop = announcementBar.getAttribute("data-autodelay-desktop")
    }
    var swiper_2 = new Swiper('.announcement-bar__slider',{
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }, 
        breakpoints: {
          767: {
            slidesPerView: 1,
            autoplay: {
              delay: delayMobile,
              disableOnInteraction: false,
            }
          },
          960: {
            slidesPerView: 1,
          }
        },
        autoplay: {
          delay: delayDesktop,
          disableOnInteraction: false
        }
    });
  } catch (e) {
    console.log(e)
  }
});